import { LeafletMouseEvent } from 'leaflet';
import { useCallback, useMemo, useState } from 'react';
import { MapContainer, Rectangle, TileLayer, useMap, useMapEvent } from 'react-leaflet';

import { POSITION_CLASSES } from '@/constants';
import { useEventHandlers } from '@react-leaflet/core';

const BOUNDS_STYLE = { weight: 1 }
const ZOOM_DIFFERENCE = 5

const clampedZoom = (zoom: number) => {
  return Math.max(0, Math.min(zoom, 18))
}

const MinimapBounds = ({ parentMap }: { parentMap: L.Map }) => {
  const minimap: L.Map = useMap();

  const onClick = useCallback(
    (e: LeafletMouseEvent) => {
      parentMap.setView(e.latlng, parentMap.getZoom())
    },
    [parentMap],
  )
  useMapEvent('click', onClick);

  const [bounds, setBounds] = useState(parentMap.getBounds())

  const onChange = useCallback(() => {
    setBounds(parentMap.getBounds())
    minimap.setView(parentMap.getCenter(), clampedZoom(parentMap.getZoom() - ZOOM_DIFFERENCE))
  }, [minimap, parentMap])

  const handlers = useMemo(() => ({ move: onChange, zoom: onChange }), [onChange]);
  // TODO: I have no idea what this means or how this works
  useEventHandlers({ instance: parentMap, context: { __version: 1, map: parentMap } }, handlers);

  return <Rectangle bounds={bounds} pathOptions={BOUNDS_STYLE} />
}

function MinimapControl({ position, className }: { position: string; className?: string }) {
  const parentMap = useMap()
  const mapZoom = clampedZoom(parentMap.getZoom() - ZOOM_DIFFERENCE)
  const minimap = useMemo(
    () => (
      <MapContainer
        style={{ height: 80, width: 80 }}
        center={parentMap.getCenter()}
        zoom={mapZoom}
        dragging={false}
        doubleClickZoom={false}
        scrollWheelZoom={false}
        attributionControl={false}
        zoomControl={false}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <MinimapBounds parentMap={parentMap} />
      </MapContainer>
    ),
    [mapZoom, parentMap],
  )

  const positionClass = (position && POSITION_CLASSES[position as keyof typeof POSITION_CLASSES]) || POSITION_CLASSES.topright;

  return (
    <div className={`${positionClass} ${className || ''}`}>
      <div className="leaflet-control leaflet-bar">{minimap}</div>
    </div>
  )
}

export { MinimapControl };
